module.exports = __webpack_public_path__ + "account/assets/whatsapp.fb6607bd.svg";